import React, { Ref, useEffect, useRef } from "react";

type AutoGrowTextareaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minHeight?: number;
  maxHeight?: number;
  disabled?: boolean;
  onReady?: (textareaRef: Ref<HTMLTextAreaElement>) => void
};

const AutoGrowTextarea: React.FC<AutoGrowTextareaProps> = ({
  value,
  onChange,
  placeholder = "Write a reply...",
  minHeight = 50,
  maxHeight = 200,
  disabled = false,
  onReady
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;

    onChange(e.target.value);
  };

  useEffect(() => {
    if(textareaRef.current && onReady){
      onReady(textareaRef);
    }
  }, [textareaRef, onReady])

  return (
    <textarea
      ref={textareaRef}
      className="comment-reply-input"
      value={value}
      disabled={disabled}
      onChange={handleChange}
      placeholder={placeholder}
      rows={1}
      style={{ minHeight, maxHeight }}
    />
  );
};

export default AutoGrowTextarea;
